import React from 'react'
import { createRoot } from 'react-dom/client'
import './translations/i18n'
import App from './App'
import moment from 'moment-timezone'

moment.tz.setDefault('Europe/Madrid')

window.jwt = ''

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
	<App/>
)